export default {"src":"/_next/static/media/furniture-and-decor.98905485.svg","height":25,"width":23,"blurWidth":0,"blurHeight":0};